// Lumen Reformas · página que envuelve la escena 3D.
// Rendimiento: el texto y un fotograma fijo del comedor (póster) se pintan al instante; la escena 3D carga detrás y se funde
// encima cuando está lista. Texturas en un worker desde el primer momento (texloader.js); three.js en un fichero aparte.
import { STAGES, stageOf } from './stages.js';
import { startTextures } from './texloader.js';
// Programa SOLO contra la API del contrato (BRIEF.md): createScene → { ready, setProgress, setBlind,
// toggleBlind, isBlindOpen, setPointer, hitTest, getStage, onStage, resize, start, stop, setQuality, dispose }.

const $ = (s) => document.querySelector(s);
const $$ = (s) => [...document.querySelectorAll(s)];
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

const raiz = document.documentElement;
raiz.classList.add('js');

const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const finePointer = matchMedia('(pointer: fine)').matches;
const mqMovil = matchMedia('(max-width: 899px)');
const LERP = 0.08; // por fotograma a 60 Hz; en frame() se corrige con dt para que la inercia sea igual a 120/144 Hz

/* ------------------------------------------------------------------ arranque de la escena, lo primero
   Se pide ya el módulo de la escena (three.js incluido). En cuanto llega, las texturas (descarga + mapas derivados)
   arrancan en un worker mientras three.js se evalúa y se monta la geometría. (Antes no: competirían con la descarga
   del póster y del propio módulo.) */
const lite0 = mqMovil.matches;
let texturas = 0;
let tex = null;
// el módulo se pide con reintento (hasta 3, con otra URL: un import() fallido queda en la caché de módulos)
const importaEscena = (n = 0) => import(new URL(__SCENE__ + (n ? `?r=${n}` : ''), import.meta.url).href)
  .catch((e) => { if (n >= 3) throw e; return new Promise(r => setTimeout(r, 300 * (n + 1))).then(() => importaEscena(n + 1)); });
// se pide justo después del primer pintado (un fotograma): la descarga y evaluación de three.js no compiten con el primer
// render del texto y del póster. No es una espera para «esquivar» nada: todo ocurre igual, en cuanto la página se ha pintado.
const trasPrimerPintado = new Promise((r) => { if (document.visibilityState === 'hidden') r(); else requestAnimationFrame(() => setTimeout(r, 0)); }); // pestaña en segundo plano: sin esperar
const escenaModulo = trasPrimerPintado.then(() => importaEscena()).then((m) => {
  tex = startTextures({ base: 'assets/tex/' + (lite0 ? '1k/' : ''), lite: lite0, onLoaded: () => { texturas++; } });
  return m;
});

/* ------------------------------------------------------------------ secciones inferiores
   Van ANTES de la escena: si el 3D falla, la página sigue teniendo revelados y formulario. */
const revelables = $$('[data-reveal]');
if ('IntersectionObserver' in window && !reduced) {
  const io = new IntersectionObserver((entradas) => {
    for (const en of entradas) {
      if (!en.isIntersecting) continue;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  revelables.forEach((el) => io.observe(el));
} else {
  revelables.forEach((el) => el.classList.add('is-in'));
}

$('#form').addEventListener('submit', (e) => {
  e.preventDefault();
  $('#form-demo').textContent = 'Formulario de demostración: aquí no se envía nada. En la web real recibirías la solicitud por correo.';
});

/* ------------------------------------------------------------------ referencias de la escena */
const canvas = $('#scene');
const seccion = $('#escena');
const sticky = $('.sticky');
const lienzo = $('.lienzo');
const panels = $$('.panel');
const pasos = $$('.etapas button');
const btn = $('#persiana');
const btnTxt = btn.querySelector('.persiana__txt');
const pista = $('#pista');
const pistaTxt = $('#pista-txt');
const aviso = $('#aviso');
const anuncio = $('#anuncio');
const cabecera = $('.top');
const pre = $('#preloader');
const preNum = $('#pre-num');
const preBar = $('#pre-bar');
const preTxt = $('#pre-txt');

/* ------------------------------------------------------------------ indicador de carga de la escena
   Ya no tapa la página: el texto y el póster se ven desde el primer momento y la escena 3D se prepara detrás.
   Progreso creíble: mezcla las texturas realmente descargadas con una curva de tiempo para la parte que no se puede
   medir (compilación de shaders, primer fotograma). Nunca retrocede. */
const TEXTURAS_ESPERADAS = 9;

const FRASES = ['Midiendo el comedor…', 'Eligiendo roble, cal y lino…', 'Colocando el parquet en espiga…', 'Ajustando la luz de la mañana…', 'Subiendo la persiana…'];
const tCarga = performance.now();
let mostrado = 0;
let listo = false;
let frase = 0;
let finCarga;
const cargaTerminada = new Promise((r) => { finCarga = r; });
const preTimer = setInterval(() => {
  const t = performance.now() - tCarga;
  const curva = 1 - Math.exp(-t / 2600);
  const real = Math.min(1, texturas / TEXTURAS_ESPERADAS);
  const meta = listo ? 100 : Math.min(96, Math.max(8 + 34 * curva, real * 78 + 18 * curva));
  mostrado = Math.max(mostrado, mostrado + (meta - mostrado) * (listo ? 0.3 : 0.1));
  if (listo && mostrado > 99.4) mostrado = 100;
  preNum.textContent = String(Math.round(mostrado));
  preBar.style.transform = `scaleX(${mostrado / 100})`;
  const f = Math.min(FRASES.length - 1, Math.floor(mostrado / (100 / FRASES.length)));
  if (f !== frase) { frase = f; preTxt.textContent = FRASES[f]; }
  if (mostrado >= 100) { clearInterval(preTimer); finCarga(); }
}, 60);

function revelaPagina() {
  pre.classList.add('is-done');
  raiz.classList.add('is-ready');
  setTimeout(() => { pre.hidden = true; }, 900);
}
// cuando la escena ya se ha fundido encima (0,9 s), el póster sobra: se retira
function retiraPoster() { const pic = lienzo.querySelector('picture'); if (pic) setTimeout(() => { pic.hidden = true; }, 1200); }

/* ------------------------------------------------------------------ escena */
let api = null;
/* ------------------------------------------------------------------ etapas / paneles (funcionan ya, sin esperar a la escena)
   Los límites salen de la tabla compartida con la escena (stages.js). */
const N = panels.length;
const limites = STAGES.slice(0, N).concat(1);
let objetivo = 0;
let actual = -1; // fuerza el primer setProgress
let etapaActual = -1;
function leerScroll() {
  const recorrido = seccion.offsetHeight - sticky.offsetHeight;
  const y = -seccion.getBoundingClientRect().top;
  objetivo = recorrido > 0 ? clamp(y / recorrido, 0, 1) : 0;
  // la cabecera se vuelve sólida cuando la sección 3D empieza a salir por arriba
  cabecera.classList.toggle('is-solid', y > recorrido + sticky.offsetHeight * 0.45);
  if (!api) { muestraEtapa(stageOf(objetivo)); pintaAvance(objetivo); } // mientras carga la escena, el texto sigue al scroll
}
addEventListener('scroll', leerScroll, { passive: true });
leerScroll();
// clic en una etapa → scroll hasta el punto en que esa etapa ya se ve resuelta
pasos.forEach((el, k) => el.addEventListener('click', () => {
  const p = k === 0 ? 0 : k === N - 1 ? 1 : limites[k] + (limites[k + 1] - limites[k]) * 0.82;
  scrollTo({ top: scrollParaProgreso(p), behavior: reduced ? 'instant' : 'smooth' });
}));

try {
  const { createScene } = await escenaModulo;
  api = await createScene({ canvas, quality: lite0 ? 'lite' : 'high', tex, reducedMotion: reduced });
  await api.ready;
} catch (err) {
  clearInterval(preTimer);
  preNum.textContent = '—';
  preTxt.textContent = 'No se ha podido cargar la escena 3D. Puedes seguir bajando para ver la información.';
  btn.hidden = true;
  setTimeout(revelaPagina, 1800);
  throw err;
}
listo = true;

function scrollParaProgreso(p) {
  const recorrido = seccion.offsetHeight - sticky.offsetHeight;
  const topAbs = seccion.getBoundingClientRect().top + scrollY;
  return topAbs + p * recorrido;
}

/* ------------------------------------------------------------------ etapas / paneles */
function muestraEtapa(i) {
  if (i === etapaActual) return;
  etapaActual = i;
  panels.forEach((el, k) => {
    el.classList.toggle('is-active', k === i);
    el.classList.toggle('is-out', k < i);
    el.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    el.inert = k !== i;
  });
  pasos.forEach((el, k) => {
    const li = el.parentElement;
    li.classList.toggle('is-active', k === i);
    li.classList.toggle('is-done', k < i);
    if (k === i) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
  });
  if (i > 0 && api) ocultaPista();
}
function pintaAvance(p) {
  const i = etapaActual;
  if (i < 0) return;
  const t = clamp((p - limites[i]) / Math.max(1e-6, limites[i + 1] - limites[i]), 0, 1);
  pasos[i].parentElement.style.setProperty('--t', t.toFixed(3));
}
api.onStage((i) => muestraEtapa(i));


/* ------------------------------------------------------------------ persiana */
function pintaPersiana(inmediato) {
  const abierta = api.isBlindOpen();
  btn.dataset.abierta = String(abierta);
  btnTxt.textContent = abierta ? 'Bajar persiana' : 'Subir persiana';
  btn.setAttribute('aria-label', abierta ? 'Bajar persiana (tecla B)' : 'Subir persiana (tecla B)'); // el nombre accesible empieza por el texto visible
  // el cristal de la tarjeta cambia con la luz: al bajar, cuando se encienden las lámparas (≈65 % del recorrido)
  // (frame() lo sincroniza con el estado real de las luces de la escena; aquí solo el caso inmediato)
  if (inmediato) sticky.dataset.luz = abierta ? 'dia' : 'noche';
}
function pintaLuz() {
  const luz = (api.getNight ? api.getNight() > 0.5 : !api.isBlindOpen()) ? 'noche' : 'dia';
  if (sticky.dataset.luz !== luz) sticky.dataset.luz = luz;
}

let pistaVista = false;
function ocultaPista() {
  if (pistaVista) return;
  pistaVista = true;
  pista.classList.add('is-hidden');
  setTimeout(() => { pista.hidden = true; }, 500);
}

let avisoTimer = 0;
function anuncia(abierta) {
  const txt = abierta ? 'Persiana subida. Entra la luz del día.' : 'Persiana bajada. Luces encendidas.';
  anuncio.textContent = '';
  requestAnimationFrame(() => { anuncio.textContent = txt; });
  aviso.textContent = abierta ? 'Persiana subida · luz de día' : 'Persiana bajada · luces encendidas';
  aviso.classList.add('is-on');
  clearTimeout(avisoTimer);
  avisoTimer = setTimeout(() => aviso.classList.remove('is-on'), 2400);
}

// onda en el punto de clic (coordenadas relativas al lienzo)
function onda(x, y) {
  const el = document.createElement('span');
  el.className = 'onda';
  el.style.left = `${x}px`;
  el.style.top = `${y}px`;
  lienzo.appendChild(el);
  el.addEventListener('animationend', () => el.remove(), { once: true });
  setTimeout(() => el.remove(), 1600);
}

function alterna(x, y) {
  api.toggleBlind();
  pintaPersiana(false);
  anuncia(api.isBlindOpen());
  if (x == null) { x = ventana.cx; y = ventana.cy; }
  if (!reduced) onda(x, y);
  ocultaPista();
}
btn.addEventListener('click', () => alterna());
addEventListener('keydown', (e) => {
  if (e.key !== 'b' && e.key !== 'B') return;
  if (!visible || e.repeat) return; // con la escena fuera de la vista (y parada) la tecla no hace nada
  const t = e.target;
  if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
  if (e.altKey || e.ctrlKey || e.metaKey) return;
  e.preventDefault();
  alterna();
});

/* ------------------------------------------------------------------ dónde está el ventanal en pantalla
   Se muestrea hitTest en una rejilla: sirve para colocar la pista SOBRE el ventanal (y no en un rótulo suelto)
   y para dar la respuesta visual cuando la persiana se acciona con el botón o el teclado. */
const ventana = { cx: 0, cy: 0 };
function localizaVentana() {
  const r = canvas.getBoundingClientRect();
  if (!r.width || !r.height) return;
  let x0 = 1, x1 = -1, y0 = 1, y1 = -1, n = 0;
  try {
    const NX = 36, NY = 22;
    for (let j = 0; j < NY; j++) for (let i = 0; i < NX; i++) {
      const nx = -1 + (2 * (i + 0.5)) / NX, ny = -1 + (2 * (j + 0.5)) / NY;
      if (api.hitTest(nx, ny) !== 'blind') continue;
      n++; x0 = Math.min(x0, nx); x1 = Math.max(x1, nx); y0 = Math.min(y0, ny); y1 = Math.max(y1, ny);
    }
  } catch { n = 0; }
  if (n < 6) { x0 = -0.35; x1 = 0.75; y0 = -0.35; y1 = 0.7; }
  let izq = ((x0 + 1) / 2) * r.width, der = ((x1 + 1) / 2) * r.width;
  const arriba = ((1 - y1) / 2) * r.height, abajo = ((1 - y0) / 2) * r.height;
  // en escritorio la tarjeta tapa la parte izquierda del ventanal: la pista se centra en lo que queda a la vista
  if (!mqMovil.matches) {
    const tarjeta = $('.paneles').getBoundingClientRect();
    izq = Math.max(izq, tarjeta.right - r.left + 24);
  }
  if (der - izq < 80) { izq = r.width * 0.4; der = r.width * 0.9; }
  ventana.cx = (izq + der) / 2;
  ventana.cy = arriba + (abajo - arriba) * (mqMovil.matches ? 0.5 : 0.56);
  pista.style.left = `${ventana.cx}px`;
  pista.style.top = `${ventana.cy}px`;
}

/* ------------------------------------------------------------------ puntero sobre el lienzo */
function ndc(e) {
  const r = canvas.getBoundingClientRect();
  return [((e.clientX - r.left) / r.width) * 2 - 1, -(((e.clientY - r.top) / r.height) * 2 - 1)];
}
let ultimoMove = null;
let moveRaf = 0;
canvas.addEventListener('pointermove', (e) => {
  ultimoMove = e;
  if (moveRaf) return;
  moveRaf = requestAnimationFrame(() => {
    moveRaf = 0;
    const ev = ultimoMove;
    const [nx, ny] = ndc(ev);
    if (ev.pointerType === 'mouse' || finePointer) {
      const encima = api.hitTest(nx, ny) === 'blind';
      canvas.style.cursor = encima ? 'pointer' : '';
      pista.classList.toggle('is-hover', encima);
      if (finePointer && !reduced) api.setPointer(nx, ny);
    }
  });
});
canvas.addEventListener('pointerleave', () => {
  canvas.style.cursor = '';
  pista.classList.remove('is-hover');
  if (finePointer && !reduced) api.setPointer(0, 0);
});
// clic sobre la ventana → persiana. Se ignora si el puntero se ha arrastrado (scroll táctil).
let down = null;
canvas.addEventListener('pointerdown', (e) => { down = [e.clientX, e.clientY]; });
canvas.addEventListener('pointerup', (e) => {
  if (!down) return;
  const dx = e.clientX - down[0], dy = e.clientY - down[1];
  down = null;
  if (Math.hypot(dx, dy) > 8) return;
  const [nx, ny] = ndc(e);
  if (api.hitTest(nx, ny) !== 'blind') return;
  const r = lienzo.getBoundingClientRect();
  alterna(e.clientX - r.left, e.clientY - r.top);
});
canvas.addEventListener('pointercancel', () => { down = null; });

/* ------------------------------------------------------------------ bucle */
let visible = true;
let raf = 0;
let previo = 0;
let frames = 0, tFps = performance.now(); // contador de fps para la herramienta de capturas: vive en este bucle y se para con él
function frame(now) {
  raf = 0;
  if (!visible) return;
  const dt = Math.min(0.05, previo ? (now - previo) / 1000 : 1 / 60); previo = now;
  frames++; if (now - tFps > 1000) { window.__fps = Math.round(frames * 1000 / (now - tFps)); frames = 0; tFps = now; }
  if (actual < 0 || reduced) actual = objetivo;
  else actual += (objetivo - actual) * (1 - Math.pow(1 - LERP, dt * 60));
  if (Math.abs(objetivo - actual) < 0.0004) actual = objetivo;
  api.setProgress(actual);
  const s = api.getStage(actual);
  if (s !== etapaActual) muestraEtapa(s);
  pintaAvance(actual);
  pintaLuz();
  raf = requestAnimationFrame(frame);
}
function arranca() {
  visible = true; previo = 0;
  api.start();
  if (!raf) raf = requestAnimationFrame(frame);
}
function para() {
  visible = false;
  api.stop();
  if (raf) { cancelAnimationFrame(raf); raf = 0; }
}
new IntersectionObserver(([en]) => { en.isIntersecting ? arranca() : para(); }, { threshold: 0 }).observe(sticky);
// girar la tableta o cruzar los 899 px cambia el tier en caliente
mqMovil.addEventListener('change', (e) => api.setQuality(e.matches ? 'lite' : 'high'));

/* ------------------------------------------------------------------ resize */
let rsz = 0;
let locTimer = 0;
new ResizeObserver(() => {
  if (rsz) return;
  rsz = requestAnimationFrame(() => {
    rsz = 0;
    api.resize();
    leerScroll();
    clearTimeout(locTimer);
    locTimer = setTimeout(localizaVentana, 200);
  });
}).observe(canvas);

/* ------------------------------------------------------------------ arranque */
leerScroll();
pintaPersiana(true);
api.setProgress(objetivo);
actual = objetivo;
arranca();

await cargaTerminada;
revelaPagina();
retiraPoster();
// la escena se funde sobre el póster; después aparecen el botón y la pista
setTimeout(() => {
  muestraEtapa(api.getStage(objetivo));
  localizaVentana();
  pistaTxt.textContent = finePointer ? 'Haz clic en el ventanal' : 'Toca el ventanal';
  if (etapaActual === 0) { pista.hidden = false; requestAnimationFrame(() => pista.classList.add('is-on')); }
  else pistaVista = true;
}, reduced ? 0 : 350);

// Herramienta de QA: window.__scene con la MISMA API, pero setProgress/setBlind también sincronizan la página
// (scroll y estado del botón) para que las capturas muestren lo que vería una persona en ese punto.
window.__scene = Object.assign(Object.create(api), {
  setProgress(p) {
    p = clamp(+p || 0, 0, 1);
    scrollTo({ top: scrollParaProgreso(p), behavior: 'instant' });
    leerScroll();
    objetivo = p; actual = p;
    api.setProgress(p);
    muestraEtapa(api.getStage(p));
    pintaAvance(p);
  },
  setBlind(open, immediate) {
    api.setBlind(open, immediate);
    pintaPersiana(immediate);
  },
  toggleBlind() { alterna(); },
});
window.__sceneReady = true;
